import React from 'react'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { StyledBiennale } from 'components'
import styled, { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import useScreenSize from 'hooks/useScreenSize'
import { useStakeContractAddress } from 'state/global/hooks'
import { isLastItem } from '@mprolab/sdk'
import { TableHeader } from '../components'
import SingleAutostake from './components/SingleAutoStake'

dayjs.extend(duration)

const StyledDescription = styled(StyledBiennale)`
  font-size: 18px;
`

const Container = styled(Flex)`
  width: 100%;
  padding: 24px;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.backgroundContrast};
`

const Divider = styled(Flex)`
  margin: 8px 0 16px 0;
  opacity: 0.2;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray6};
`
const BorderContainer = styled(Flex)<{ isLast: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.gray7};
  padding: 8px;
  border-radius: 8px;
  flex-direction: column;
  margin-bottom: ${({ isLast }) => (isLast ? '0' : '16px')};
`

const AutoStake: React.FC = () => {
  const allStakeContracts = useStakeContractAddress()
  const { t } = useTranslation()
  const { colors } = useTheme()
  const { isMobile } = useScreenSize()

  const headerContent = ['stake', 'token', 'earn', 'apy', 'fee']

  const mobileView = (
    <Flex flexDirection="column">
      <Flex fullWidth mb="16px" justifyContent="space-between">
        <StyledDescription>{t('stakingPanel.nodesAutostake')}</StyledDescription>
        <Text
          clickable
          variant={TextVariant.BODY_SMALL_MEDIUM}
          color={colors.purple}
          onClick={() => window.open(import.meta.env.VITE_STAKING_DOCS_URL, '_blank')}
        >
          {t('stakingPanel.learnMore')}
        </Text>
      </Flex>

      <>
        {allStakeContracts.map((contract) => (
          <Container key={contract.address}>
            <SingleAutostake
              name={contract.name}
              address={contract.address}
              key={contract.address}
              chainId={contract.chainId}
            />
          </Container>
        ))}
      </>
    </Flex>
  )

  const desktopView = (
    <Container>
      <Flex fullWidth mb="16px" justifyContent="space-between">
        <StyledDescription>{t('stakingPanel.nodesAutostake')}</StyledDescription>
        <Text
          clickable
          variant={TextVariant.BODY_SMALL_MEDIUM}
          color={colors.purple}
          onClick={() => window.open(import.meta.env.VITE_STAKING_DOCS_URL, '_blank')}
        >
          {t('stakingPanel.learnMore')}
        </Text>
      </Flex>
      <TableHeader {...{ headerContent }} />
      <Divider />

      <>
        {allStakeContracts.map((contract, index) => (
          <BorderContainer isLast={isLastItem(allStakeContracts, index)} key={contract.address}>
            <SingleAutostake
              name={contract.name}
              address={contract.address}
              key={contract.address}
              chainId={contract.chainId}
            />
          </BorderContainer>
        ))}
      </>
    </Container>
  )

  return <>{isMobile ? mobileView : desktopView}</>
}

export default AutoStake
